import { Col } from "react-bootstrap";
import { ProjectContent } from "./ProjectContent";

export const ProjectCard = ({ title, description, imageUrl, url, fixed }) => {
  return (
    <Col sm={6} md={4}>
      <div
        className="proj-imgbx"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <ProjectContent
          title={title}
          description={description}
          imageUrl={imageUrl}
          url={url}
          fixed={fixed}
        />
      </div>
    </Col>
  );
};
